function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "12",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.863 3.975l.67 4.17a.79.79 0 00.78.664h9.374a.79.79 0 00.78-.665l.67-4.169c.12-.74-.764-1.214-1.315-.706l-1.238 1.143a.79.79 0 01-1.213-.174L7.678 1.41a.79.79 0 00-1.355 0L4.629 4.238a.79.79 0 01-1.213.174L2.178 3.269c-.55-.508-1.434-.034-1.315.706z",
  fill: "#F78BCC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 10.771h8",
  stroke: "#F78BCC",
  strokeWidth: "1.731",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));